export default {
  target: "目標・実績管理",
  evaluation: "評価項目管理",
  settingCommon: "共通情報設定",
  history: "評価履歴閲覧機能",
  memberTransfer: "人事異動メンバー",
  dataCollection: "データ集計",
};
